const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3020';

export default apiBaseUrl;
